import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { ISavAnalytics } from "../models/SavAnalytics";
import { DefaultResponseWithData } from "../models/system";

const MARKETPLACE_SOURCE_ID = "00000000-0000-0000-0000-000000000000";

export default function useSavAnalytics(
  from: Date,
  to: Date,
  enabled: boolean,
  sourceCustomerId?: string | null
) {
  const { get } = useApiHelper();

  const fromStr = from.toISOString().split("T")[0];
  const toStr = to.toISOString().split("T")[0];
  const sourceKey = sourceCustomerId ?? "all";

  const statsQuery = useQuery<DefaultResponseWithData<ISavAnalytics>>({
    queryKey: ["savAnalytics", fromStr, toStr, sourceKey],
    queryFn: () => {
      const params = new URLSearchParams({ from: fromStr, to: toStr });
      if (sourceCustomerId === "marketplace") {
        params.set("sourceCustomerId", MARKETPLACE_SOURCE_ID);
      } else if (sourceCustomerId) {
        params.set("sourceCustomerId", sourceCustomerId);
      }
      return get<DefaultResponseWithData<ISavAnalytics>>(`/stats/sav?${params.toString()}`);
    },
    enabled,
    staleTime: 1000 * 60,
  });

  return {
    statsQuery,
    stats: statsQuery.data?.data,
  };
}
